import ReactMarkdown from "react-markdown";
import { Link, useParams } from "react-router";
import remarkGfm from "remark-gfm";
import { categoryAnchor } from "../lib/links";
import type { TaxonomyEntry } from "../sources/taxonomy";

export function ConditionDetail({ entry }: { entry: TaxonomyEntry }) {
  const { tenant } = useParams();
  return (
    <div className="condition-detail">
      <p className="condition-short">{entry.short_description}</p>
      <div className="condition-full">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          disallowedElements={["script", "style", "iframe"]}
          skipHtml
        >
          {entry.full_description}
        </ReactMarkdown>
      </div>
      {entry.vectors.length > 0 ? (
        <p className="condition-vectors">
          <span className="meta-label">Infection vectors</span>
          {entry.vectors.map((v) => (
            <span key={v} className="pill">
              {v}
            </span>
          ))}
        </p>
      ) : null}
      {entry.category && tenant ? (
        <p className="condition-vectors">
          <span className="meta-label">Category</span>
          <Link
            to={`/${tenant}/conditions#${categoryAnchor(entry.category)}`}
            className="cat-link"
            onClick={(e) => e.stopPropagation()}
          >
            {entry.category}
          </Link>
        </p>
      ) : null}
      {!entry.has_observer ? (
        <p className="condition-vectors">
          <span className="meta-label">Detector status</span>
          <span className="pill dim">no observer in v0</span>
        </p>
      ) : null}
    </div>
  );
}
